import axios from "axios";

class FetchAPI {
    fetch;
    constructor(library) {
        this.fetch = library;
    }

    async get(url, configuration = {}) {
        try {
            const request = await axios.get(url, configuration);
            return this.authenticateUnauthorizedRequests(request);
        } catch(error) {
            return this.handleRequestError(error);
        }
    }

    async post(url, configuration = {}, data ={}) {
        try {
            const request = await axios.post(url, data, configuration)
            return this.authenticateUnauthorizedRequests(request);
        } catch(error) {
            return this.handleRequestError(error);
        }
    }

    async put(url, configuration = {}, data ={}) {
        try {
            const request = await axios.put(url, data, configuration)
            return this.authenticateUnauthorizedRequests(request);
        } catch(error) {
            return this.handleRequestError(error);
        }
    }

    async patch(url, configuration = {}, data = {}) {
        try {
            const request = await axios.patch(url, data, configuration);
            return this.authenticateUnauthorizedRequests(request);
        } catch (error) {
            return this.handleRequestError(error);
        }
    }

    async delete(url, configuration = {}) {
        try {
            const request = await axios.delete(url, configuration)
            return this.authenticateUnauthorizedRequests(request);
        } catch(error) {
            return this.handleRequestError(error);
        }
    }

    authenticateUnauthorizedRequests(response) {
        if (response?.status === 401) {
            this.handleLogout();
        }
        return response;
    }

    handleRequestError(error) {
        if (error.response?.status === 401) {
            this.handleLogout();
        }
        return Promise.reject(error);
    }

    handleLogout() {
        console.warn("Unauthorized! Logging out...");
        document.cookie.split(";").forEach(function(cookie) {
            const name = cookie.split("=")[0].trim();
            document.cookie = name + "=; path=/; domain=.commenter.ai; max-age=0";
            document.cookie = name + "=; path=/; domain=commenter.ai; max-age=0";
        });
        localStorage.clear();
        window.location.href = "https://commenter.ai/login";
    }
}

export const fetchAPI = new FetchAPI(axios);